import React, {createContext, FC, useCallback, useContext, useState} from "react";
import TextTranslationModal from "./TextTranslationModal";
import {TranslationField} from "./TextTranslationEditor";
import {AreaLanguageOption, TextTranslation} from "../types";

export type TranslationDialogConfig = {
    areaId?: string;
    clientId?: string;
    defaultLanguage?: string;
    availableLanguages?: AreaLanguageOption[];
    publishedAt?: number;
    canEdit: boolean;
    title?: string;
    description?: string;
    fields: TranslationField[];
    onTranslationSaved?: (translation: TextTranslation) => void;
};

type TranslationDialogContextI = {
    open: (config: TranslationDialogConfig) => void;
    close: () => void;
};

const TranslationDialogContext = createContext<TranslationDialogContextI>({
    open: () => undefined,
    close: () => undefined
});

export const useTranslationDialog = () => useContext(TranslationDialogContext);

export const TranslationDialogProvider: FC<{children: React.ReactNode}> = ({children}) => {
    const [config, setConfig] = useState<TranslationDialogConfig | undefined>(undefined);

    const open = useCallback((nextConfig: TranslationDialogConfig) => {
        setConfig(nextConfig);
    }, []);

    const close = useCallback(() => {
        setConfig(undefined);
    }, []);

    return (
        <TranslationDialogContext.Provider value={{open, close}}>
            {children}
            {config ? (
                <TextTranslationModal
                    isOpen={true}
                    onClose={close}
                    areaId={config.areaId}
                    clientId={config.clientId}
                    defaultLanguage={config.defaultLanguage}
                    availableLanguages={config.availableLanguages}
                    publishedAt={config.publishedAt}
                    fields={config.fields}
                    canEdit={config.canEdit}
                    title={config.title}
                    description={config.description}
                    onTranslationSaved={config.onTranslationSaved}
                />
            ) : null}
        </TranslationDialogContext.Provider>
    );
};
